// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3a773039","849":"10fecddb"}[chunkId] + ".chunk.js";
};